import React from "react";
import { useTranslation } from "react-i18next";

import {
  QuestionComponentProps,
  QuestionDefinition,
  QuestionOption,
} from "../../Question";
import { MultipleChoiceQuestion } from "../core";

const QUESTION_ID = "healthCareProfessional";

declare module "@/contexts" {
  interface SurveyAnswers {
    healthCareProfessional?: string;
  }
}

const HealthCareProfessionalQuestion: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
  surveyAnswers,
}) => {
  const { t } = useTranslation();

  const options: QuestionOption[] = [
    { id: "doctor", text: t("healthCareProfessional.options.doctor") },
    { id: "pharmacist", text: t("healthCareProfessional.options.pharmacist") },
    {
      id: "anotherProfessional",
      text: t("healthCareProfessional.options.anotherProfessional"),
    },
    { id: "no", text: t("healthCareProfessional.options.no") },
  ];

  return (
    <MultipleChoiceQuestion
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      options={options}
      questionId={QUESTION_ID}
      questionText={t("healthCareProfessional.questionText")}
      selectedItem={surveyAnswers[QUESTION_ID] || ""}
    />
  );
};

export const Q_HEALTH_CARE_PROFESSIONAL: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["DPP"],
  shouldShowQuestion: () => true,
  component: HealthCareProfessionalQuestion,
};

export const Q_RETRIAGE_HEALTH_CARE_PROFESSIONAL: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["DPP"],
  shouldShowQuestion: () => true,
  component: HealthCareProfessionalQuestion,
};
